/* globals document */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { killEvent } from 'event-helpers';
import displayName from 'component-lib/displayName';

import download from '../../lib/download';

import DocumentViewerHeader from './DocumentViewerHeader';
import DocumentViewerBody from './DocumentViewerBody';

import styles from './DocumentViewer.scss';

const DEFAULT_BODY_WIDTH = 60;
const MAX_BODY_WITH = 95;

export default class DocumentViewer extends Component {
    static displayName = displayName('DocumentViewer/DocumentViewer');

    static propTypes = {
        waitForLoading: PropTypes.bool,
        documentIndex: PropTypes.number,
        userCanDownloadDocuments: PropTypes.bool,
        documents: PropTypes.arrayOf(PropTypes.shape({
            filename: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
            downloadUrl: PropTypes.string.isRequired,
        }),).isRequired,
        onClose: PropTypes.func.isRequired,
    };

    static defaultProps = {
        userCanDownloadDocuments: true,
        waitForLoading: true,
        documentIndex: 0,
    };

    constructor(props) {
        super(props);

        this.oitDocument = null;

        this.state = {
            documentIndex: props.documentIndex,
            isLoaded: !props.waitForLoading,
            loadingFailed: false,
            pageIndex: 1,
            pagesTotal: 1,
        };

        const timer = setInterval(() => {
            const iframe = document.getElementById('attachment-rendered-view');

            if (iframe) {
                const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

                if (iframeDoc.body && !!iframeDoc.body.children.length) {
                    this.onOitAttachmentLoaded();
                    clearInterval(timer);
                }
            }
        }, 1000);
    }

    onOitAttachmentLoaded = () => {
        if (!this.state.isLoaded) {
            this.setState({ isLoaded: true });
        }
    };

    onNext = (e) => {
        killEvent(e);
        this.resetPageView(Math.min(this.state.documentIndex + 1, this.documentsLength));
    };

    onPrev = (e) => {
        killEvent(e);
        this.resetPageView(Math.max(this.state.documentIndex - 1, 0));
    };

    onDownload = (e) => {
        killEvent(e);

        if (this.props.userCanDownloadDocuments) {
            download(this.document.downloadUrl);
        }
    };

    onLoadContent = (e) => {
        this.setState({ isLoaded: true });

        const iframeStyles = document.createElement('style');
        iframeStyles.textContent =
      'img { max-height: 100%; max-width: 100%; width: auto; height: auto; position: absolute; top: 0; bottom: 0; left: 0; right: 0; margin: auto; }';
        // eslint-disable-next-line no-unused-expressions
        e.target?.contentDocument?.head?.appendChild?.(iframeStyles);
    };

    onZoom = () => {
    // onZoom
    };

    get document() {
        return this.props.documents[this.state.documentIndex];
    }

    get documentsLength() {
        return this.props.documents.length;
    }

    get fileDetails() {
        const fileDetails = this.document;
        const type = fileDetails.filename.match(/\.([0-9a-z]+)$/i);

        return {
            type: type ? type[1] : '',
            ...this.document,
        };
    }

    get bodyWidth() {
        return Math.min(this.state.documentZoom * DEFAULT_BODY_WIDTH, MAX_BODY_WITH);
    }

    resetPageView(documentIndex) {
        this.setState({
            documentIndex,
            isLoaded: !this.props.waitForLoading,
        });

        if (this.oitDocument) {
            this.oitDocument.OIT.document.removeEventListener('idle', this.oncheckDocumentPages);
            this.oitDocument = null;
        }
    }

    render() {
        return (
            <div role="presentation" className={styles['dv-container']} onClick={this.props.onClose}>
                <DocumentViewerHeader
                    file={this.fileDetails}
                    onDownload={this.onDownload}
                    {...this.props}
                />
                <DocumentViewerBody
                    {...this.props}
                    bodyWidth={this.bodyWidth}
                    onLoadContent={this.onLoadContent}
                    onPrev={this.onPrev}
                    onNext={this.onNext}
                    onZoom={this.onZoom}
                    url={this.document.url}
                    isLoaded={this.state.isLoaded}
                    documentIndex={this.state.documentIndex}
                    documentsTotal={this.documentsLength}
                    pageIndex={this.state.pageIndex}
                    pagesTotal={this.state.pagesTotal}
                    loadingFailed={this.state.loadingFailed}
                />
            </div>
        );
    }
}
